'use strict';

/**
 * This directive when added to a scroll area will add a gradient to the bottom
 * and top of the scroll area when not at their maximum.
 */
const ScrollFadeVerticalDir = {
    bind: function (el, binding) {
        const opts = Object.assign({
            top     : true,
            bottom  : true,
        }, binding.value || {});

        const showTopFade = (element) => element.scrollTop !== 0;
        const showBottomFade = (element) => (element.scrollHeight - element.scrollTop) !== element.clientHeight;

        el.addEventListener('scroll', (event) => {
            const element = event.target;
            element.classList.remove('el-scroll-fade-vertical', 'el-scroll-fade-top', 'el-scroll-fade-bottom');

            const showTop = opts.top && showTopFade(element);
            const showBottom = opts.bottom && showBottomFade(element);

            //  An element can have only one mask, so we need to check if we should fade both top & bottom or only one side
            if (showTop && showBottom) {
                element.classList.add('el-scroll-fade-vertical');
            } else if (showTop) {
                element.classList.add('el-scroll-fade-top');
            } else if (showBottom) {
                element.classList.add('el-scroll-fade-bottom');
            }
        });

        //  Check on element load if we should display fade at the bottom
        if (showBottomFade(el)) {
            el.classList.add('el-scroll-fade-bottom');
        }

        //  We use the resize observer because the list might be populated by ajax call
        if (opts.bottom) {
            const resizeObserver = new ResizeObserver((entries) => {
                requestAnimationFrame(() => {
                    for (const entry of entries) {
                        if (showBottomFade(entry.target)) {
                            entry.target.classList.add('el-scroll-fade-bottom');
                        }
                    }
                });
            });

            resizeObserver.observe(el);
        }
    },
    unbind: function () {},
};

/**
 * Bind the scroll fade vertical directive to Vue.
 * use with `v-ath-scroll-fade-vertical` or `v-mead-scroll-fade-vertical`.
 * The `v-ath-scroll-fade-vertical` version is deprecated; use `v-mead-scroll-fade-vertical` instead.
 */
const ScrollFadeVerticalDirective = {
    /**
     * Bind the scroll fade vertical directive to Vue.
     * use with `v-ath-scroll-fade-vertical` or `v-mead-scroll-fade-vertical`.
     * The `v-ath-scroll-fade-vertical` version is deprecated; use `v-mead-scroll-fade-vertical` instead.
     */
    bind: function (vue) {
        vue.directive('athScrollFadeVertical', ScrollFadeVerticalDir);
        vue.directive('meadScrollFadeVertical', ScrollFadeVerticalDir);
    }
}

export default ScrollFadeVerticalDirective;
